import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import useLocalesStore from '@/store/modules/locale'
import useAuthStore from '@/store/modules/auth'
import useAppStore from '@/store/modules/app'
import useEvenStore from '@/store/modules/event'
import useThemeStore from '@/store/modules/theme'
import useChannelFrameworkStore from '@/store/modules/channel-framework'
import useGlobalSearchStore from '@/store/modules/global-search'
import usePermissionStore from '@/store/modules/permission'

export interface IAppStore {
  localeStore: ReturnType<typeof useLocalesStore>
  authStore: ReturnType<typeof useAuthStore>
  appStore: ReturnType<typeof useAppStore>
  evenStore: ReturnType<typeof useEvenStore>
  themeStore: ReturnType<typeof useThemeStore>
  channelFrameworkStore: ReturnType<typeof useChannelFrameworkStore>
  globalSearchStore: ReturnType<typeof useGlobalSearchStore>
  permissionStore: ReturnType<typeof usePermissionStore>
}

export const storeInstance = createPinia()
storeInstance.use(piniaPluginPersistedstate)

export {
  useLocalesStore,
  useAuthStore,
  useAppStore,
  useEvenStore,
  useThemeStore,
  useChannelFrameworkStore,
  useGlobalSearchStore,
  usePermissionStore,
}

const store: IAppStore = {} as IAppStore

export function registerStore() {
  store.localeStore = useLocalesStore()
  store.authStore = useAuthStore()
  store.appStore = useAppStore()
  store.evenStore = useEvenStore()
  store.permissionStore = usePermissionStore()
  store.themeStore = useThemeStore()
  store.globalSearchStore = useGlobalSearchStore()
  store.channelFrameworkStore = useChannelFrameworkStore()
  return store
}

export default store
